<template>
  <b-container>
    <h1>WS2812 Ring Demo</h1>
    <b-form inline class="justify-content-center">
      <label for="deviceID">Device ID: &nbsp;</label>
      <b-input v-model="deviceID" class="mb-2 mr-sm-2 mb-sm-0" placeholder="Device ID"></b-input>
      <b-button variant="primary" @click="updateDevice">OK</b-button>
      &nbsp;&nbsp;Status = {{status}}
    </b-form>
    <br />
    <b-card title="Smart Connection" bg-variant="light" class="mb-2">
      <b-card-text>
        <ul>
          <li>Connect TX to DI</li>
          <li>Connect VCC to 5V</li>
          <li>Connect GND to GND</li>
        </ul>
      </b-card-text>
    </b-card>

    <b-card title="Ring Test" bg-variant="light" class="imgcard">
      <b-card-text>
        <img src="https://i.imgur.com/2AvseHp.gif" img-alt="Card image" height="180" />
        <p>A red point will circulate forever.</p>
        <b-button variant="primary" @click="ringTest">Ring Test</b-button>
      </b-card-text>
    </b-card>

    <b-card title="Clock Test" bg-variant="light" class="imgcard">
      <b-card-text>
        <img src="https://i.imgur.com/v3UQi70.gif" img-alt="Card image" height="180" />
        <p>Red=Hour, Green=Min, Blue=Sec</p>
        <b-button variant="primary" @click="clockTest">Clock Test</b-button>
      </b-card-text>
    </b-card>
  </b-container>
</template>

<script>
var webduino = require("webduino-js");

export default {
  data: function() {
    return {
      deviceID: "",
      status: "N/A",
      board: null,
      timer: null
    };
  },
  methods: {
    updateDevice: function() {
      window.console.log("Connecting...");
      this.status = "Connecting...";
      this.board = new webduino.WebArduino(this.deviceID);
      //window.console.log(this.board)
      var _this = this;
      this.board.on(webduino.BoardEvent.READY, function() {
        window.console.log("Connected!");
        _this.status = "Connected!";
        _this.board.samplingInterval = 100;
        _this.ws2812_init(1, 16);
        _this.ws2812_setColor("0100FF00");
      });
    },
    ringTest: function() {
      var _this = this;
      var a = 0;
      if (this.timer != null) {
        window.clearInterval(this.timer);
      }
      this.timer = window.setInterval(function() {
        var pattern = "";
        for (var i = 0; i < 16; i++) {
          var k = (i + 6) % 16;
          var color = "000000";
          if (k == a % 12) {
            color = "ff0000";
          }
          pattern += _this.ws2812_toHex(k) + color;
          continue;
        }
        _this.ws2812_setColor(pattern);
        a = a + 1;
      }, 100);
    },
    clockTest: function() {
      var _this = this;
      if (this.timer != null) {
        window.clearInterval(this.timer);
      }
      this.timer = window.setInterval(function() {
        var today = new Date();
        var hour = today.getHours();
        window.console.log(hour);
        if (hour > 11) {
          hour -= 12;
        }
        var min = today.getMinutes();
        var sec = today.getSeconds();
        _this.ws2812_off();
        _this.ws2812_setColor((Math.round(sec / 5) + 6) % 12, "#000010");
        _this.ws2812_setColor((Math.round(min / 5) + 6) % 12, "#001000");
        _this.ws2812_setColor((hour + 6) % 12, "#100000");
      }, 1000);
    },
    ws2812_init: function(pin, leds) {
      var cmd = "";
      if (leds <= 64) {
        cmd = [0xf0, 0x04, 0x21, 0x0 /*init*/, leds, pin, 0xf7];
      } else {
        var h6bit = leds >>> 6;
        var l6bit = leds & 0x3f;
        cmd = [0xf0, 0x04, 0x21, 0x4 /*init*/, h6bit, l6bit, pin, 0xf7];
      }
      this.board.send(cmd);
    },
    ws2812_setColor: function(led, color) {
      if (led > 64) {
        this.ws2812_setColor64(led, color);
        return;
      }
      var data = "";
      var cmd = [0xf0, 0x04, 0x21, 0x03];
      if (arguments.length == 1) {
        data = led;
      } else {
        data = data.concat(this.ws2812_toHex(led));
        data = data.concat(color.substring(1));
      }
      for (var i = 0; i < data.length; i++) {
        cmd.push(data.charCodeAt(i));
      }
      cmd.push(0xf7);
      this.board.send(cmd);
      this.board.flush();
    },
    ws2812_setColor64: function(led, color) {
      var data = "";
      var cmd = [0xf0, 0x04, 0x21, 0x05];
      cmd.push(led >>> 6);
      cmd.push(led & 0x3f);
      data = data.concat(color.substring(1));
      for (var i = 0; i < data.length; i++) {
        cmd.push(data.charCodeAt(i));
      }
      cmd.push(0xf7);
      this.board.send(cmd);
      this.board.flush();
    },
    ws2812_off: function() {
      this.board.send([0xf0, 0x04, 0x21, 0x02, 0xf7]);
    },
    ws2812_brightness: function(b) {
      var data = this.toHex(b);
      this.board.send([0xf0, 0x04, 0x21, 0x01, data, 0xf7]);
      this.board.flush();
    },
    ws2812_toHex: function(num) {
      var str = num.toString(16);
      if (parseInt(num) < 16) {
        str = "0" + str;
      }
      return str;
    }
  }
};
</script>

<style scoped>
h1 {
  margin: 24px 0;
  background: blue;
  color: white;
  padding: 12px;
  text-align: center;
}
img {
  position: absolute;
  bottom: 0;
  right: 0;
}
.card {
  max-width: 550px;
  margin: 0 auto;
}
.imgcard {
  overflow: auto;
  height: 200px;
}
</style>
